import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ContactProvider } from './context/ContactContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileCallBar from './components/MobileCallBar';
import CallReservationPopup from './components/CallReservationPopup';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import BookingPage from './pages/BookingPage';
import ConfirmationPage from './pages/ConfirmationPage';
import MyBookingsPage from './pages/MyBookingsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HelpPage from './pages/HelpPage';
import DestinationsPage from './pages/DestinationsPage';
import AirlinesPage from './pages/AirlinesPage';
import FlightResultsPage from './pages/FlightResultsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import ServiceFeesPage from './pages/ServiceFeesPage';
import UnitedAirlinesPage from './pages/UnitedAirlinesPage';
import NewBookingPage from './pages/NewBookingPage';
import FlightChangesPage from './pages/FlightChangesPage';
import AirlineChangePage from './pages/AirlineChangePage';
import IcelandairPage from './pages/IcelandairPage';
import LufthansaPage from './pages/LufthansaPage';
import BritishAirwaysPage from './pages/BritishAirwaysPage';
import SwissPage from './pages/SwissPage';
import CathayPacificPage from './pages/CathayPacificPage';
import TapPortugalPage from './pages/TapPortugalPage';
import KlmPage from './pages/KlmPage';
import AirFrancePage from './pages/AirFrancePage';
import ItaAirwaysPage from './pages/ItaAirwaysPage';
import AmericanAirlinesPage from './pages/AmericanAirlinesPage';
import DeltaAirLinesPage from './pages/DeltaAirLinesPage';
import JetBluePage from './pages/JetBluePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function AppShell() {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin-dashboard') || pathname.startsWith('/admin-login');

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdminRoute && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/airline-reservation" element={<HomePage />} />
          <Route path="/airline-change" element={<AirlineChangePage />} />
          <Route path="/expedia/airlines" element={<HomePage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/my-bookings" element={<MyBookingsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/airlines" element={<AirlinesPage />} />
          <Route path="/flights" element={<FlightResultsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/service-fees" element={<ServiceFeesPage />} />
          <Route path="/ua/airlines" element={<UnitedAirlinesPage />} />
          <Route path="/fi/airlines" element={<IcelandairPage />} />
          <Route path="/lh/airlines" element={<LufthansaPage />} />
          <Route path="/ba/airlines" element={<BritishAirwaysPage />} />
          <Route path="/lx/airlines" element={<SwissPage />} />
          <Route path="/cx/airlines" element={<CathayPacificPage />} />
          <Route path="/tp/airlines" element={<TapPortugalPage />} />
          <Route path="/kl/airlines" element={<KlmPage />} />
          <Route path="/af/airlines" element={<AirFrancePage />} />
          <Route path="/az/airlines" element={<ItaAirwaysPage />} />
          <Route path="/aa/airlines" element={<AmericanAirlinesPage />} />
          <Route path="/dl/airlines" element={<DeltaAirLinesPage />} />
          <Route path="/b6/airlines" element={<JetBluePage />} />
          <Route path="/newbooking" element={<NewBookingPage />} />
          <Route path="/flightchanges" element={<FlightChangesPage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <MobileCallBar />}
      {!isAdminRoute && <CallReservationPopup />}
    </div>
  );
}

function App() {
  return (
    <ContactProvider>
      <Router>
        <AppShell />
      </Router>
    </ContactProvider>
  );
}

export default App;
